var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.fields,"items":_vm.events,"items-per-page":15,"dense":"","calculate-widths":""},scopedSlots:_vm._u([{key:`item.create_date`,fn:function({ item }){return [_vm._v(" "+_vm._s(_vm._f("localtime")(item.create_date))+" ")]}}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }